import type { Command } from './types';

function selectedNodeId(ctx: { editorState: { selectedNodeIds: string[] } }): string | undefined {
  return ctx.editorState.selectedNodeIds[0];
}

export const connectionCommands: Command[] = [
  {
    id: 'connection.startAdd',
    label: 'Start Adding Connection',
    category: 'connection',
    canExecute: (ctx) => {
      const id = selectedNodeId(ctx);
      return !!id && ctx.editorState.mode !== 'connecting';
    },
    execute: (ctx) => {
      const id = selectedNodeId(ctx);
      if (id) {
        ctx.editorState.startConnecting(id);
      }
    },
  },
  {
    id: 'connection.cancel',
    label: 'Cancel Connection',
    category: 'connection',
    canExecute: (ctx) => ctx.editorState.mode === 'connecting',
    execute: (ctx) => {
      ctx.editorState.cancelConnecting();
    },
  },
];
